/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {BonusBunniesServerDataParser} from "../BonusBunniesServerDataParser";
import {IBonusBunniesGameData, IBonusBunniesInitData} from "./IBonusBunniesGameData";
import {FeatureBuyTimesBetValue} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";

export class BonusBunniesParsedInitData extends ParsedInitData {

    private _bottomRowActivated:boolean;
    private _lastReelActivated:boolean;
    private _totalBonusWinMultiplierBefore:number;
    private _totalBonusWinMultiplierAfter:number;
    private _bonusValuesBeforeSpin:number[][];
    private _bonusPositionsBeforeSpin:boolean[][];
    private _bonusOverlaySymbols:string[][];
    private _bonusSpinsRemaining:number;
    private _orginalReels:string[][];

    private readonly _accumulatedRoundWin:string;
    public get accumulatedRoundWin():string {
        return this._accumulatedRoundWin;
    }

    private readonly _featureBuyTimesBetValue:FeatureBuyTimesBetValue[];
    public get featureBuyTimesBetValue():FeatureBuyTimesBetValue[] {
        return this._featureBuyTimesBetValue;
    }

    constructor(rawData:IBonusBunniesInitData, dataParser:BonusBunniesServerDataParser) {
        const orginalReels:string[][] = dataParser.parseOriginalReelData(rawData);
        rawData.bonusOverlaySymbols = dataParser.parseB4bonusOverlaySymbolsInitData(rawData);
        rawData.reels = dataParser.parseReelData(rawData);
        rawData.freespinsLeft = rawData.bonusSpinsRemaining;
        super(rawData, dataParser);
        this._orginalReels = orginalReels;
        this._bottomRowActivated = rawData.bottomRowActivated;
        this._lastReelActivated = rawData.lastReelActivated;
        this._totalBonusWinMultiplierBefore = rawData.totalBonusWinMultiplierBefore;
        this._bonusValuesBeforeSpin = rawData.bonusValuesBeforeSpin;
        this._bonusOverlaySymbols = rawData.bonusOverlaySymbols;
        this._bonusSpinsRemaining = rawData.bonusSpinsRemaining;
        this._totalBonusWinMultiplierAfter = rawData.totalBonusWinMultiplierAfter;
        this._bonusPositionsBeforeSpin = rawData.bonusPositionsBeforeSpin;
        this._featureBuyTimesBetValue = rawData.featureBuyTimesBetValue;
        this._accumulatedRoundWin = rawData.accumulatedRoundWin;
    }

    get bottomRowActivated():boolean {
        return this._bottomRowActivated;
    }

    get lastReelActivated():boolean {
        return this._lastReelActivated;
    }

    get totalBonusWinMultiplierBefore():number {
        return this._totalBonusWinMultiplierBefore;
    }

    get bonusValuesBeforeSpin():number[][] {
        return this._bonusValuesBeforeSpin;
    }

    get bonusOverlaySymbols():string[][] {
        return this._bonusOverlaySymbols;
    }

    get bonusSpinsRemaining():number {
        return this._bonusSpinsRemaining;
    }

    get totalBonusWinMultiplierAfter():number {
        return this._totalBonusWinMultiplierAfter;
    }

    get orginalReels():string[][] {
        return this._orginalReels;
    }

    get bonusPositionsBeforeSpin():boolean[][] {
        return this._bonusPositionsBeforeSpin;
    }
}